import { render, staticRenderFns } from "./companyOrder.vue?vue&type=template&id=014e8bd2&scoped=true&"
import script from "./companyOrder.vue?vue&type=script&lang=js&"
export * from "./companyOrder.vue?vue&type=script&lang=js&"
import style0 from "./companyOrder.vue?vue&type=style&index=0&id=014e8bd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014e8bd2",
  null
  
)

export default component.exports